import React, {Component} from 'react';
import Blueitems from '../../components/Blueitems'
import VettrisHeader from '../../components/VettrisHeader'
import Breakpoints from '../../utils/breakpoints'
import contentfulData from '../../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import MapComponent from '../../components/MapComponent';
import NewsLetter from '../../components/NewsLetter';
import VettrisFooter from '../../components/VettrisFooter';
import ArticleImageWithText from '../../components/ArticleImageWithText';
import ArticleHighlight from '../../components/ArticleHighlight';
import GuideArticle from '../../components/GuideArticle';
import {prettifyUrl, getLang} from '../../utils/util-functions';
import Colors from '../../utils/colors'
import ParentGuide from '../../components/ParentGuide';
import _ from 'lodash';
import Breadcrumbs from '../../components/Breadcrumbs';

export class IndexPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      searchString: {article: ""},
      path: ""
    };
    this.changeUrl = this.changeUrl.bind(this);
    this.onPopstate = this.onPopstate.bind(this);
    this.onHashChange = this.onHashChange.bind(this);
  }

  changeUrl (headline){
    this.props.history.push("/"+this.state.path[0]+"/#article="+prettifyUrl(headline));
    this.setState({
      searchString: {article: prettifyUrl(headline)}
    });
  }

  onPopstate(){
    this.setState({
      searchString: window.location.hash ? {article: window.location.hash.split("article=")[1]} : ""
    });
  }

  onHashChange(){
    this.setState({
      searchString: window.location.hash ? {article: window.location.hash.split("article=")[1]} : ""
    });
  }

  componentDidMount() {
    setTimeout(() => { document.body.scrollTop = 0;}, 2);

    this.setState({
      path: location ? location.pathname.split('/').filter((strPiece) => strPiece.length>1) : "",
      searchString: location ? {article: window.location.hash.split("article=")[1]} : {article: ""}
    });
    window.addEventListener("popstate", this.onPopstate);
    window.addEventListener("hashchange", this.onHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopstate);
    window.removeEventListener('hashchange', this.onHashChange);
  }

  render() {

    const brand = getLang();
    const items = contentfulData.servicesData[brand].services;
    const title = contentfulData.singleData[brand].singleData.frontpageItemHeader;
    const secondTitle = contentfulData.singleData[brand].singleData.frontpageSecondTitle;
    const paragraph = contentfulData.singleData[brand].singleData.frontpagelongtext;
    const mapTitle = contentfulData.singleData[brand].singleData.frontpageMapTitle;
    const mapItems = contentfulData.clinicsData[brand].clinicsData;
    const emailText = contentfulData.singleData[brand].singleData.frontpageEmailText;
    const guides = contentfulData.guideArticlesData[brand].guideArticlesData;
    const currenNewstTitle = contentfulData.singleData[brand].singleData.frontpageWidgetTitle;

    const SingleGuide = (props) => {
      let mappedByUrlArticles = guides.map(item => {
        return {url: prettifyUrl(item.articleHeadline), item};
      });

      let articleByUrl = _.find(mappedByUrlArticles, item => item.url===props.article);

      return (
          <div className="col-xs-12" style={styles.divider}>
            {articleByUrl ? <GuideArticle activeLink={props.article} path={this.state.path[0]} articles={mappedByUrlArticles} history={this.props.history}/> : "404 Article not found."}
          </div>
      )
    };


    const componentByPath = this.state.searchString.article ? <SingleGuide article={this.state.searchString.article} history={this.props.history}/> : <ParentGuide clickFunc={this.changeUrl} history={this.props.history} />;

    return (
        <div>
          <VettrisHeader history={this.props.history}/>
          <StyleRoot>
            <div style={styles}>
                <Breadcrumbs />
                { componentByPath }
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <div className="col-xs-12"><h2 style={{marginTop: Breakpoints.componentDivider, fontFamily: 'Merriweather'}}>{title}</h2></div>
                  <Blueitems items={items} history={this.props.history}/>
                  <div className="clearfix"></div>
                  <div className="col-xs-12"> <h2 style={{marginTop: Breakpoints.componentDivider, fontFamily: 'Merriweather'}}>{secondTitle}</h2></div>
                  <div className="col-xs-12"><p>{paragraph}</p></div>
                  <div className="clearfix" style={{marginTop: Breakpoints.componentDivider}}></div>
                  {  _.sortBy(guides.filter(g => g.articleHighlight), [guide => guide.articleImage])
                      .map((guide, a) => {
                        if (guide.articleImage)
                          return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleImageWithText key={a} twoPanels={true} title={currenNewstTitle} headline={guide.articleHeadline} image={guide.articleImage.fields.file.url} /></div></div>
                        if (guide.articleHighlight)
                          return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(guide.articleHeadline)} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}><ArticleHighlight key={a} headline={guide.articleHeadline} /></div></div>
                        return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(guide.articleHeadline)} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}>{guide.articleHeadline}</div></div>
                      }
                  )}
                </div>
                <div className="col-md-4 col-xs-12" style={styles.firstRow} >
                  <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="col-xs-12"><NewsLetter text={emailText} /></div>
                </div>
              </div>
              <div style={{marginTop: Breakpoints.componentDivider}}></div>
            </div>
          </StyleRoot>
          <VettrisFooter />
        </div>
    )
  }
}

export default Radium(IndexPage)

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  firstRow: {
    marginTop: 90,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: 20
    }
  },
  divider: {
    marginTop: 20
  },
  singleArticle: {
    marginTop: 20,
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    marginLeft: 20,
    paddingLeft: 0
  },
  typeContainer: {
    paddingRight: 40,
  },
  dividerSingleItem: {
    marginTop: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },
  singleArticleLink: {
    textDecoration: 'none',
    color: Colors.darkBlue,
    ':hover': {
      cursor: 'pointer'
    }
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  }
};


// WEBPACK FOOTER //
// ./src/pages/guides/index.js